<template>
    <div class="show-strategy-modal">
        <div class="modal-wrap">
            <div class="modal-header">
                <h4>{{ data.name }}</h4>
                <p v-if="data.updateTime">{{ data.updateTime }}</p>
                <a class="close-btn" @click="close"></a>
            </div>
            <div class="modal-content">
                <div class="show-strategy-detail">
                    <div v-if="data.content instanceof Array">
                        <div v-for="(content, index) in data.content" :key="index" class="strategy-item">
                            <img :src="content.image" alt="" v-if="content.wtType === 'GuidePicture'" class="strategy-img" />
                            <span v-if="content.wtType === 'GuideText'" class="strategy-text" v-html="content.content"></span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="preview-ex" ref="exContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { createEditor } from "@tencent/exeditor3-preset-editor";

export default {
    name: "GuidesViewModal",
    props: ["data"],
    data() {
        return {
            editor: null,
        }
    },
    mounted() {
        if (!(this.data.content instanceof Array)) {
            this.editor = createEditor({
                root: this.$refs.exContent,
                initialContent: this.data.content,
            });
            this.editor.setReadOnly(true);
        }
    },
    methods: {
        close() {
            this.$emit("closeModal");
        }
    }
};
</script>

<style lang="less" scoped>
.show-strategy-modal {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .modal-wrap {
        min-width: 300px;
        min-height: 150px;
        position: relative;
        border-radius: 8px;
        box-shadow: 0px 5px 8px rgba(90, 98, 111, 0.25);
        background: #fff;
        max-height: 70%;
        display: flex;
        flex-direction: column;

        .modal-header {
            padding: 4px 23px;
            font-size: 16px;
            background: #e4f1f9;
            border-radius: 8px 8px 0 0;
            text-align: center;
            & > p {
                font-size: 12px;
            }
            .close-btn {
                cursor: pointer;
                position: absolute;
                top: 0;
                right: 0;
                width: 44px;
                height: 38px;
                background: url("@{zhijiStaticImagePath}i-close.png") center center no-repeat;
            }
        }
        .modal-content {
            padding: 24px;
            box-sizing: border-box;
            flex: 1;
            display: flex;
            overflow-y: auto;
            .show-strategy-detail {
                width: 812px;
                flex: 1;
                overflow-y: auto;
                border: 1px solid #d8e4f0;
                box-sizing: border-box;
                background: #fafbfd;
                border-radius: 4px;
                padding: 16px;
                img {
                    max-width: 100%;
                    margin-bottom: 10px;
                }
                .preview-ex {
                    position: relative;
                    z-index: 1;
                    ::v-deep strong {
                        font-style: inherit;
                        font-weight: bold;
                    }
                    ::v-deep h1 {
                        display: block;
                        font-size: 2em;
                        margin-block-start: 0.67em;
                        margin-block-end: 0.67em;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                        font-weight: bold;
                    }
                    ::v-deep h2 {
                        display: block;
                        font-size: 1.5em;
                        margin-block-start: 0.83em;
                        margin-block-end: 0.83em;
                        margin-inline-start: 0px;
                        margin-inline-end: 0px;
                        font-weight: bold;
                    }
                    ::v-deep sub {
                        vertical-align: sub;
                    }
                    ::v-deep sup {
                        vertical-align: super;
                    }
                }
            }
        }
    }
}
</style>
